var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleInfo = function SvgCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6543 10.154C10.6543 9.78888 10.7626 9.43195 10.9654 9.12835C11.1683 8.82475 11.4566 8.58812 11.794 8.44839C12.1313 8.30866 12.5025 8.2721 12.8606 8.34334C13.2187 8.41457 13.5477 8.5904 13.8059 8.84859C14.0641 9.10678 14.2399 9.43573 14.3111 9.79385C14.3824 10.152 14.3458 10.5232 14.2061 10.8605C14.0663 11.1978 13.8297 11.4862 13.5261 11.689C13.2225 11.8919 12.8656 12.0002 12.5005 12.0002V13.2309",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4992 15.0767C12.3167 15.0767 12.1382 15.1308 11.9864 15.2322C11.8346 15.3337 11.7163 15.4778 11.6464 15.6465C11.5766 15.8152 11.5583 16.0008 11.5939 16.1798C11.6295 16.3589 11.7174 16.5234 11.8465 16.6525C11.9756 16.7815 12.1401 16.8695 12.3192 16.9051C12.4982 16.9407 12.6838 16.9224 12.8525 16.8525C13.0212 16.7827 13.1653 16.6644 13.2668 16.5126C13.3682 16.3608 13.4223 16.1823 13.4223 15.9997C13.4191 15.7559 13.3209 15.523 13.1484 15.3505C12.976 15.1781 12.7431 15.0798 12.4992 15.0767Z",
    fill: "currentColor"
  })));
};
export default SvgCircleInfo;